import { pipe, match, toLower, map, join } from 'ramda'

export default pipe(
  match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g),
  map(toLower),
  join('-'),
)
